export default __webpack_public_path__ + "static/media/arunNehruProfileImage.57482690.webp";